export default {
    //Splash
    splash_message: 'Aloqa va trening platformasi',

    //TTCC
    accept_ttcc: 'Foydalanish shartlari va qoidalarini qabul qiling',

    //Login
    welcome: 'Xush kelibsiz!',
    welcome_message: "dots, aloqa va trening bo'yicha yangi texnologik hamkoringiz.",
    username: 'Foydalanuvchi nomi',
    password: 'Parol',
    code: 'Kod',
    recover_password: 'Parolni tiklash',
    log_in: 'Kirish',
    log_in_biometrics: 'Biometrik ma´lumotlar bilan tizimga kiring',
    create_user: 'Foydalanuvchi yaratish',
    recover_access_to_account: 'Hisobingizga kirishni tiklash uchun foydalanuvchi nomingizni kiriting',
    back: 'Orqaga',
    enter_new_password: 'Kod va yangi parolingizni kiriting',
    enter_code: 'Kod kiriting',
    new_password: 'Yangi parol',
    repeat_new_password: 'Yangi parolni takrorlang',
    validate: 'Tasdiqlash',
    complete_all_fields: "Barcha maydonlarni to'ldiring",
    passwords_do_not_match: 'Parollar mos emas',
    user_created_successfully: 'Foydalanuvchi muvaffaqiyatli yaratildi',
    create_user: 'Foydalanuvchi yaratish',
    required_fields: 'Majburiy maydonlar',
    confirm_your_email: 'Emailingizni tasdiqlang',
    confirm_your_phone: 'Telefoningizni tasdiqlang',
    confirm_password: 'Parolingizni tasdiqlang',
    modifying_email: 'Siz emailingizni',
    validate_code: 'Kod tasdiqlang',
    code_sent_successfully: 'Kod muvaffaqiyatli yuborildi',
    password_reset: 'Parolingiz muvaffaqiyatli tiklandi',
    enter_confirmation_code: 'Tasdiqlash kodini kiriting',
    enter_your_new_email: 'Yangi elektron pochta manzilingizni kiriting',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Voy! Hisobingizni topa olmadik',
    contact_the_administrator:
        'Kiritgan foydalanuvchingiz mavjud emasga o‘xshaydi.\nUni to‘g‘ri yozilganligini tekshiring\nyoki administrator bilan bog‘laning.',
    invalid_user_or_pass: 'Noma’lum foydalanuvchi nomi va/yoki parol',
    info_is_not_correct: 'Ba’zi ma´lumotlar noto‘g‘ri, iltimos qayta urinib ko‘ring.',
    enter_user: 'Iltimos, foydalanuvchi nomini kiriting',
    nonexistent_user: 'Mavjud bo‘lmagan foydalanuvchi. Iltimos, qayta urinib ko‘ring.',
    incorrect_code: 'Noto‘g‘ri kod',
    change_saved_successfully: 'O‘zgartirish muvaffaqiyatli saqlandi',
    pass_changed_successfully: 'Parol muvaffaqiyatli o‘zgartirildi',
    check_your_email: 'Tasdiqlash kodini kiriting uchun elektron pochtangizni tekshiring',
    eight_characters: '*8 ta belgidan ko‘p bo‘lishi kerak',
    one_uppercase_letter: '*Kamida 1 ta katta harf bo‘lishi kerak',
    one_special_character: '*Kamida 1 ta maxsus belgi bo‘lishi kerak (@,$,!,#,?)',
    pass_requirements:
        'Siz quyidagi talablarni bajarishingiz kerak:\n\n*8 ta belgidan ko‘p bo‘lishi kerak\n*Kamida 1 ta katta harf bo‘lishi kerak\n*Kamida 1 ta maxsus belgi bo‘lishi kerak (masalan: $, !, #, ?)',
    select_date: 'Sanani tanlang',
    cannot_create_password: 'Parol yaratilmayapti',
    complete_your_details: 'Davom etish uchun ma´lumotlaringizni to‘ldiring',
    validate_code: 'Kod tasdiqlang',
    enter_valid_number: 'To‘g‘ri raqam kiriting',
    complete_numbers:
        '"15" prefiksini olib tashlash kerak, shunda yakuniy raqamda jami 13 raqam bo‘ladi, masalan: +54 9 XXX XXX XXXX, qolgan 10 raqamni to‘ldirishingiz kerak.',

    //Profile
    insufficient_permissions: 'Ruxsatlar yetarli emas',
    permissions_are_required: 'Kamera va foto galereyaga kirish uchun ruxsat talab qilinadi.',
    choose_font: 'Manbani tanlang',
    where_do_you_want: 'Rasmni qayerdan tanlamoqchisiz?',
    camera: 'Kamera',
    gallery: 'Galereya',
    edit_photo: 'Rasmni tahrirlash',
    cancel: 'Bekor qilish',
    save: 'Saqlash',
    app: 'Ilova',
    support: "Qo'llab-quvvatlash",
    other: 'Boshqa',
    contact_channel: 'Aloqa kanali',
    select_the_contact_channel: 'Aloqa kanalini tanlang',
    subject: 'Mavzu',
    write_the_subject: 'Mavzuni yozing',
    message: 'Xabar',
    write_a_comment: 'Izoh yozing',
    send: 'Yuborish',
    sent_successfully: 'Muvaffaqiyatli yuborildi',
    thank_you_for_leaving_us_your_comments: "Izohlaringiz uchun rahmat, tez orada siz bilan bog'lanamiz.",
    close: 'Yopish',
    check_for_update: 'Yangilanishlarni tekshirish',
    clear_cache: 'Keshni tozalash',
    delete_account: "Hisobni o'chirish",
    log_out: 'Chiqish',
    notifications: 'Bildirishnomalar',
    insufficient_permissions: 'Ruxsatlar yetarli emas',
    permissions_to_access: 'Kamera va foto galereyaga kirish uchun ruxsat talab qilinadi.',
    choose_font: 'Manbani tanlang',
    select_the_image: 'Rasmni qayerdan tanlamoqchisiz?',
    change_language: 'Tilni o´zgartirish',
    change_language_title: 'Muhim!',
    change_language_message:
        'Ushbu amalni bajarish uchun internet aloqasi bo´lishi kerak. Bu oflayn foydalanish uchun yuklab olingan kontentni oʻchirib tashlaydi. Esda tutingki, oʻzgartirish faqat ilova tarkibiga taʼsir qiladi, ilova tuzilishiga emas, bu qurilmangiz tiliga bogʻliq.',
    logout_not_available: 'Chiqish mavjud emas',
    cant_logout: 'Hozirda internetga ulanmaganingiz sababli chiqish imkoniyati yo‘q. Iltimos, ulanishingizni tekshiring va qayta urinib ko‘ring.',
    //nuevos al 01-08-2024
    cache_cleared: 'Kesh muvaffaqiyatli tozalandi',
    deletes_the_content:
        'Bu amal ilovadan oflayn rejimda foydalanish uchun yuklab olingan kontentni oʻchirib tashlaydi. Ko‘rishni davom ettirish uchun ulanganingizga ishonch hosil qiling.',
    error_uploading_image: 'Rasmni yuklashda xato: ',
    there_was_an_error: 'Rasmni yuklashda xato yuz berdi. Iltimos, qayta urinib ko‘ring.',
    //nuevos al 21-11-2024
    email: 'Elektron pochta',
    phone: 'Telefon',
    name: 'Ism',
    last_name: 'Familiya',
    role: 'Rol',
    verify: 'Tekshirish',
    verified: 'Tasdiqlandi',
    contact_channels: 'Aloqa kanallari',
    editing_your_email: 'Siz elektron pochta manzilingizni tahrirlayapsiz',
    editing_your_phone: 'Siz telefon raqamingizni tahrirlayapsiz',
    modifying_your_email:
        "Siz elektron pochta manzilingizni o'zgartiryapsiz, uni kiritish uchun elektron pochta manzilingizga kod yuboriladi. Agar kodni hali olmagan bo'lsangiz, iltimos, yana tekshirib ko'ring.",
    modifying_your_phone:
        "Siz mobil telefon raqamingizni o'zgartiryapsiz, uni kiritish uchun SMS orqali kod yuboriladi. Agar kodni hali olmagan bo'lsangiz, iltimos, yana tekshirib ko'ring.",

    //Notifications
    all: 'Hammasi',
    unread: "O'qilmagan",
    read: "O'qilgan",
    seen: "Ko'rildi",
    notifications: 'Bildirishnomalar',
    here_you_will_find: 'Bu yerda barcha ogohlantirishlar va bildirishnomalarni topasiz!',
    mark_all_read: "Hammasini o'qilgan deb belgilash",
    you_have_no_notifications: "Sizda bildirishnomalar yo'q!",
    you_will_soon_start: 'Tez orada yangi xabarlar olasiz',

    //Buscador
    enter_your_search: 'Qidiruvingizni kiriting',
    no_results: 'Natijalar topilmadi',
    search_content: 'Sizni qiziqtirgan kontentni qidiring.',
    see: "Ko'rish",
    results_in: 'natijalar',
    see_less_results: "Kamroq natijalarni ko'rish",
    all: 'Hammasi',
    wall: 'Devor',
    learning: "O'rganish",
    benefits: 'Foydalar',
    portfolio: 'Portfel',
    retry: 'Qayta urinish',
    locked: 'Bloklangan',
    pending: 'Kutish holatida',
    seen: "Ko'rildi",
    approved: 'Tasdiqlangan',

    //Posts
    see_them: "Hammasini ko'rish",
    _comments: ' izohlar',
    reactions_from_other_users: 'Boshqa foydalanuvchilarning reaksiyalari',
    not_connected_to_the_network: 'Tarmoqga ulanmagan',
    comment: 'Izoh',
    comments: 'Izohlar',
    write_a_comment: 'Izoh yozing',
    no_content: "Kontent yo'q",
    not_connected_to_the_network: 'Tarmoqga ulanmagan',
    reaction: 'Reaksiya',
    reactions: 'Reaksiyalar',
    first_comment: "Birinchi bo'lib izoh qoldiring!",
    no_comment: "Ushbu postda hali izohlar yo'q.",
    write_a_comment: 'Izoh yozing',
    no_publications: "Nashrlar yo'q",
    no_post_to_read: "Sizda o'qish uchun postlar yo'q.",
    views: "ko'rishlar",
    reply: 'Javob berish',
    see: "Ko'rish",
    more_answers: "ko'proq javoblar",
    hide: 'Yashirish',
    answers: ' javoblar',
    no_reactions: "Hali reaksiyalar yo'q!",
    leave_your_reaction: "Birinchi bo'lib reaksiyangizni qoldiring.",
    //nuevos al 01-08-2024
    full_survey: 'So‘rovnoma to‘ldirildi!',
    thanks_for_participating: 'Ishtirok etganingiz uchun tashakkur! Ko‘proq yangilanishlar uchun devorni kuzatib boring.',
    sent_automatically: 'U avtomatik ravishda siz qayta ulanishni tiklaganingizda yuboriladi.',
    no_post_saved: 'Hali saqlangan xabarlar yo‘q',
    see_your_favorite_content: 'Bu yerda sevimli kontentingizni ko‘rasiz.',
    //fechas
    instant: 'Biroz oldin',
    hourFirst: 'Oldin',
    hour: ' soat',
    hours: ' soat',
    day: ' kun',
    days: ' kun',

    //Learning
    congratulations: 'Tabriklaymiz!',
    you_approved: 'Siz muvaffaqiyatli topshirdingiz ',
    you_completed: 'Siz ushbu kursni tugatdingiz',
    you_disapproved: 'Baholash muvaffaqiyatsiz tugadi',
    score: 'Baholash:',
    return_to_course: 'Bosh sahifaga qaytish',
    retry: 'Qayta urinish',
    it_is_available: 'Endi mavjud',
    total_course_evaluation: 'Umumiy kurs bahosi',
    evaluate_me: 'MENI BAHOLASH',
    completed_the_course: 'Siz kursni tugatdingiz',
    pending_approval: 'Tasdiqlash kutilmoqda',
    return: 'Orqaga',
    continue_course: 'Kursni davom ettirish',
    you_have_made: 'Siz tugatdingiz',
    of_the_course: ' kursning',
    locked: 'bloklangan',
    pending: 'kutish holatida',
    seen: "ko'rildi",
    complete: 'tugatish',
    reprobate: 'muvaffaqiyatsiz',
    sync_pend: 'sinx kutilmoqda',
    in_progress: 'jarayonda',
    perform_evaluation: "Baholashni o'tkazish",
    next_content: 'Keyingi kontent',
    you_completed_all: 'Siz barcha kontentlarni tugatdingiz',
    final_evaluation: 'YAKUNIY BAHOLASH',
    retry_mayus: 'QAYTA URINISH',
    see_more: "...ko'proq",
    see_less: '...kamroq',
    back_to_course: 'KURS GA QAYTISH',
    click_to_see: "Ko'rish uchun bosing",
    //Evaluaciones
    evaluation: 'Baholash: ',
    of: ' dan ',
    loading_evaluation: 'Baholash yuklanmoqda...',
    select_option: 'Davom ettirish uchun variantni tanlashingiz kerak',
    select_one_answer: 'Iltimos, har bir savol uchun kamida bitta javob tanlang.',
    exit_evaluation: 'Baholashdan chiqmoqchimisiz?',
    your_answers_will_not_be_saved: 'Agar hozir chiqib ketsangiz, javoblaringiz saqlanmaydi va baho olmaysiz',
    continue_evaluation: 'Baholashni davom ettirish',
    leave_anyway: 'Baribir chiqish',
    try_again: 'Qayta urinish!',
    passed_the_evaluation: 'Siz baholashni muvaffaqiyatli topshirdingiz',
    start_the_course_again: "Baholashdan o'tish uchun yetarli baho ololmadingiz. Kursni qayta boshlang.",
    evaluation_pending_approval: 'Baholash kutilmoqda',
    notification_result_evaluation: 'Baholash natijasi haqida tez orada xabardor qilinasiz',
    write_here: 'Bu yerga yozing...',
    close: 'Yopish',
    confirm: 'Tasdiqlash',
    sync_pending: 'Sinx kutilmoqda',
    view_certificate: 'Sertifikatni ko´rish',

    // nuevos al 27-01-2025
    course_download_in_process: 'Kurs yuklanmoqda',
    course_is_downloading:
        "Bir necha soniya kuting. Kurs yuklanmoqda, shuning uchun siz barcha kontentni oflayn holda muammosiz olish imkoniyatiga ega bo'lasiz.",
    downloaded_course: 'Kurs muvaffaqiyatli yuklandi',
    you_can_train_offline: 'Tayyor! Endi siz oflayn tarzda mashq qilishingiz mumkin.',
    delete_offline_course: "Ushbu kursning oflayn yuklanishini o'chirishni xohlaysizmi?",
    not_view_course_offline: "Siz ushbu kursni oflayn rejimda ko'ra olmaysiz.",
    course_is_not_available: 'Kurs endi mavjud emas...',
    not_available_offline: "Bu kurs endi oflayn rejimda mavjud emas, lekin kerak bo'lganda uni yana yuklab olishingiz mumkin.",
    content_download_in_process: 'Kontent yuklanmoqda',
    content_is_downloading:
        "Bir necha soniya kuting. Kontent yuklanmoqda, shuning uchun siz uni oflayn tarzda muammosiz olish imkoniyatiga ega bo'lasiz.",
    downloaded_content: 'Kontent muvaffaqiyatli yuklandi',
    delete_offline_content: "Oflayn kontentini o'chirishni xohlaysizmi?",
    not_view_content_offline: "Uni o'chirsangiz, kontentni oflayn holda ko'ra olmaysiz.",
    content_is_not_available: 'Kontent endi mavjud emas...',
    download_offline: 'Oflayn yuklash',
    available_offline: 'Oflayn mavjud',
    delete: 'Oʻchirish',
    //Stores
    your_progress_in_stores: "Do'konlardagi rivojlanishingiz",
    map: 'Xarita',
    daily_survey: "Kundalik so'rovnoma",
    survey: "So'rovnoma",
    matutino: 'ERTALAB',
    vespertino: 'KECHQURUN',
    form: 'Forma',
    enter_a_number: 'Raqam kiriting',
    campaign_expiration: 'KAMPANIYA MUHLATI: ',
    store_indicators: "Do'kon ko'rsatkichlari",
    last_days: "So'nggi 30 kunga tegishli",
    main_indicators: "Do'konning asosiy ko'rsatkichlari rivojlanishini bilib oling",
    store_information: "Mukammal do'kon darajalariga erishish uchun tegishli do'kon ma'lumotlarini toping",
    perform_executions: "Do'kon holatini bilish uchun quyidagi ijrolarni bajaring",
    pending_mayus: 'KUTILMOQDA',
    approved_mayus: 'TASDIQLANGAN',
    in_review_mayus: "KO'RIB CHIQILMOQDA",
    redo_mayus: 'QAYTA ISHLASH',
    visited_mayus: 'TASHRIF BUYURILGAN',
    visited_mayus_sync: 'TASHRIF BUYURILGAN SYNC',
    visited_store_mayus: 'DO‘KONLARGA TASHRIF BUYURILGAN',
    checkin_realized_sync: 'DO‘ KONLARGA TASHRIF BUYURILGAN SYNC',
    moderation_mayus: 'MODERATSIYA',
    review_mayus: "KO'RIB CHIQISH",
    in_progress_mayus: 'JARAYONDA',
    sync_pend_mayus: 'SINX KUTILMOQDA',
    locked_mayus: 'BLOKLANGAN',
    complete_mayus: 'TO‘LIQ',
    perfect_store: "Mukammal do'kon",
    execution: 'Ijro',
    vouchers: 'Vaucherlar',
    send: 'Yuborish',
    requires: 'Talab qiladi ',
    variation: "O'zgarish",
    validity: 'Amal qilish muddati: ',
    points: 'ball',
    voucher_canceled: 'Vaucher bekor qilindi',
    you_can_try_again: "Xavotir olmang! Yana urinib ko'ring.",
    voucher_successful: 'Vaucher muvaffaqiyatli bajarildi',
    successful_promo: 'Promo muvaffaqiyatli bajarildi!',
    voucher_pending: 'Vaucher kutilmoqda',
    wait_for_the_validation: 'Vaucherni tasdiqlashni kuting',
    your_code_is_being_scanned: 'Kodingiz skanerlanmoqda ⏳',
    view_qr: "QR-ni ko'rish",
    return_to_store: "Do'konga qaytish",
    stores_objective: "Do'konning maqsadini bajarish kerak.",
    welcome_stores: "Do'konlarga xush kelibsiz!",
    tip_day: "Bu yerda kunlik do'konlaringizni ko'rishingiz, tegishli so'rovnomalarni o'tkazishingiz va rivojlanishingizni kuzatishingiz mumkin.",
    close_mayus: 'YOPISH',
    select_form: 'Boshlash uchun formani tanlang',
    select_one_form: "So'rovnomani boshlash uchun biror bir formani tanlashingiz kerak.",
    answer_all_questions: 'Davom ettirish uchun barcha savollarga javob berishingiz kerak.',
    schedule_not_found: 'Bugun uchun jadval topilmadi.',
    form_not_found: 'Jadvalda forma topilmadi.',
    send: 'Yuborish',
    check_in: "Ro'yxatdan o'tish",
    check_out: 'Chiqish',
    check_out_done: 'Chiqish amalga oshirildi',
    off_route: "Yo'ldan chiqqansiz, jadvalga qaytish uchun bu yerga kiring",
    search_barcode: "Shtrix kod bo'yicha qidirish",
    no_agenda_today: "Bugungi kun uchun jadvalingiz yo'q!",
    no_agenda_week: "Bu hafta uchun jadvalingiz yo'q!",
    no_information_today: "Ushbu sana uchun jadvalingiz yo'q, agar savollaringiz bo'lsa, rahbaringizga murojaat qiling.",
    no_information_week: "Foydalanuvchi uchun ma'lumotlar olinmayapti, agar savollaringiz bo'lsa, rahbaringizga murojaat qiling.",
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Sizda kamera ruxsatlari mavjud emas',
    activate_from_settings: 'Davom etish uchun buni qurilmangizning sozlamalaridan yoqing.',
    modify_permissions: 'Ruxsatlarni o‘zgartirish',
    complete_fields: 'Doʻkon yaratish uchun quyidagi maydonlarni toʻldiring',
    create: 'Yaratish',
    store_name: 'Doʻkon nomi',
    enter_store_name: 'Doʻkon nomini kiriting',
    sore_address: 'Manzil',
    enter_sore_address: 'Doʻkon manzilini kiriting',
    cluster: 'Klaster',
    store_phone: 'Telefon',
    enter_sore_phone: 'Doʻkon telefon raqamini kiriting',
    activate_survey: '1.1 Vespertino soʻrovini faollashtirish uchun doʻkon maqsadlarini bajarishingiz kerak. Maqsadlar: ',
    inactive_vespertino: 'Vespertino faol emas',
    active_vespertino: 'Vespertino faol',
    completed_your_mandatory_objectives: 'Siz kunning majburiy maqsadlarini bajardingiz, endi Vespertinoʼni bajara olasiz.',
    complete_now: 'Hozir bajarish',
    perform_later: 'Keyin bajarish',
    back_to_your_agenda: 'Kunlik rejangizga qaytmoqchimisiz?',
    return_to_the_current_day:
        'Siz oldingi kunlarning faoliyatlarini ko‘rib chiqyapsiz, davom ettirish tugmasini bosganingizda, joriy kunga qaytasiz: ',
    continue: 'Davom etish',
    reached_your_goal: 'Maqsadingizga erishdingiz!',
    search_by_barcode: 'Barkod bo‘yicha qidirish',
    scan_the_barcode: 'Ushbu so‘rov ro‘yxatidagi har qanday mahsulotning barkodini skanerlashingiz mumkin.',
    return_to_form: 'Formaga qaytish',
    product_not_found: 'Mahsulot topilmadi',
    code_does_not_match: 'Kod ushbu forma bilan bog‘liq mahsulot bilan mos kelmaydi.',
    search_another_product: 'Boshqa mahsulotni qidirish',
    form_submitted_successfully: ' muvaffaqiyatga erishdi!',
    send_new_survey: 'Agar xohlasangiz, yangi so‘rov yuborishingiz mumkin.',
    no_agenda_for_today: 'Bugun uchun kun tartibi yo‘q!',
    consult_your_supervisor: 'Bu sana uchun sizda kun tartibi yo‘q, har qanday savol bo‘lsa, rahbaringiz bilan maslahatlashing.',
    visiting_your_store: 'Siz o‘z do‘koningizga tashrif buyurmoqdasiz ',
    you_can_check_out: 'So‘rovnomani to‘ldirmasdan chiqishingiz mumkin: ',
    you_met_the_goal: 'Siz maqsadga erishdingiz, shaklni to‘ldirishingiz shart emas.',
    you_must_complete_the_survey: 'Chiqish uchun siz so‘rovnomani to‘ldirishingiz kerak: ',
    checkin_blocked: 'Ro‘yxatdan o‘tish bloklandi',
    close_the_open_checkin: 'Davom etish uchun ochiq ro‘yxatdan o‘tishni yopishingiz kerak.',
    close_the_checkin_opened_in: 'Davom etish uchun ochiq ro‘yxatdan o‘tishni yopishingiz kerak: ',
    checkin_out_of_range: 'Ro‘yxatdan o‘tish diapazondan tashqarida',
    more_meters_from_the_store: 'Siz do‘kondan 150 metrdan uzoqdasiz.',
    now_is_your_turn: 'Endi sizning navbatingiz!',
    surveys_in_progress: 'Sizda davom etayotgan so‘rovnomalar mavjud: ',
    unfinished_surveys: 'Sizda tugallanmagan so‘rovnomalar mavjud: ',
    want_to_checkout: 'Chiqishni xohlayotganingizga aminmisiz?',
    selected_store: 'Tanlangan do‘kon',
    checkout_blocked: 'Chiqish bloklandi',
    uncompleted_forms: 'Sizda tugallanmagan shakllar mavjud!',
    checkout_anyway: 'Baribir chiqishni xohlaysizmi?',
    go_to_survey: 'So‘rovnomaga o‘tish',
    take_the_survey: 'Endi so‘rovnomani bajara olasiz!',
    validity: 'Amaldorlik: ',
    search_store: 'Do´konni qidirish...',
    no_results_for_your_search: 'Izlash uchun hech qanday natija topilmadi',
    find_another_store: 'Boshqa do´kon qidiring',
    //nuevos al 21-11-2024
    loading: 'Yuklanmoqda...',
    error_getting_data: "Ma'lumotlarni olishda xatolik yuz berdi.",
    no_information_to_display: "Ko'rsatish uchun ma'lumot yo'q.",
    unzipping: 'Arxivni ochish...',
    saving: 'Saqlanmoqda',
    loading_stores: "Do'konlar yuklanmoqda...",
    getting_stores: "Do'konlar olinmoqda...",
    request_has_failed: "Maksimal qayta urinib ko'rish soni yetib keldi. So'rov bajarilmadi.",
    a_few_minutes: "Do'konlar yuklanmoqda...\nUshbu jarayon bir necha daqiqa davom etishi mumkin.",
    //nuevos al 27-01-2025
    assets_download_completed: 'Perfect Store resurslari yuklab olindi',
    perfect_store_download: 'Perfect Store muvaffaqiyat fotosi yuklab olindi',
    perfect_store_error: 'Perfect Store resurslarini yuklab olishda xato yuz berdi',
    connection_interrupted: 'Aloqa uzildi, aloqa tiklangandan so´ng muvaffaqiyat fotosi arxivdan chiqariladi',
    decompressing_perfect_store: 'Perfect Store yuklab olinmoqda',
    downloading_perfect_store: 'Perfect Store yuklanmoqda',
    saving_perfect_store: 'Perfect Store saqlanmoqda',
    remain_downloaded: '\nYuklash uchun qolgan ',
    downloading_perfect_store: '',
    saving_perfect_store: '',
    assets: ' resurslar.',
    download_complete: 'Yuklash yakunlandi',

    //Portfolio
    no_brands_to_show: "Ko'rsatish uchun brendlar yo'q",
    no_products_to_show: "Ko'rsatish uchun mahsulotlar yo'q",
    try_again_later: "Keyinroq qayta urinib ko'ring",
    portfolio: 'Portfel',
    select_one: "Mahsulot va xizmatlarini ko'rish uchun brendlarimizdan birini tanlang.",
    learn_about: 'Ilovamizdagi barcha mahsulot va xizmatlar haqida bilib oling.',
    //nuevos al 01-08-2024
    brand: 'Brend',
    description: 'Tavsif',
    ingredients: 'Tarkibiy qismlar',
    data_sheet: 'Texnik ma´lumotlar varaqasi',

    //Benefits
    points_can_be_exchanged: 'Ballar quyidagilarga almashtirilishi mumkin:',
    approved: 'Tasdiqlangan',
    cancelled: 'Bekor qilingan',
    pending: 'Kutish holatida',
    redeemed: 'QUTQARILGAN',
    added_points: "BALLAR QO'SHILDI",
    all: 'Hammasi',
    my_points: 'Mening ballarim',
    your_points: 'Sizning ballaringiz',
    delivered: 'Yetkazildi',
    no_benefits: "Hozircha foyda yo'q",
    add_points: "Interaksiyalaringiz bilan ballar to'plang va ularni qutqaring",
    no_history: "Hozircha tarix yo'q",
    redeem_your_points: "Ballaringizni qutqarib oling va foyda tarixini bu yerda ko'ring",
    pending_approval: 'Tasdiqlash kutilmoqda',
    when_it_is_approved: "Tasdiqlangandan so'ng, u foyda tarixida aks etadi",
    unredeemed_benefit: 'Qutqarilmagan foyda',
    you_dont_have_enough_points: "Ushbu foydani qutqarish uchun yetarli ballaringiz yo'q",
    accept: 'Qabul qilish',
    units_available: ' mavjud birliklar',
    redeem_benefit: 'Foydani qutqarish',
    benefits_mayus: 'FOYDALAR',
    history: 'TARIX',
    there_was_a_mistake: 'Xatolik yuz berdi',

    //Vouchers
    complete_to_redeem_the_voucher: "Vaucher qutqarish uchun to'ldiring",
    valid_until: 'Amal qilish muddati: ',
    quantity_purchased: 'Sotib olingan miqdor: ',
    redeem: 'Qutqarish',
    lumps: "Bo'laklar",
    voucher_redeemed: 'Vaucher muvaffaqiyatli qutqarildi',
    error_redeeming_voucher: "Vaucherni qutqarishda xatolik yuz berdi. Qayta urinib ko'ring.",
    validate_and_redeem_vouchers: 'Vaucherni tasdiqlash va qutqarish',
    to_get_started: 'Boshlash uchun kamerangiz bilan vaucheringizning QR kodini kiriting yoki skanerlang',
    write_your_code: 'Kodingizni yozing...',
    validate: 'Tasdiqlash',
    back_to_store: "Do'konga qaytish",
    scan_qr: 'QR ni skaner qiling',
    scan_on_the_voucher: 'Boshlash uchun, kupondagi QR ni skaner qiling',
    view_history: 'Tarixni ko‘rish',
    voucher_history: 'Kupon tarixi',
    voucher_history_description:
        'Ushbu tarix sizga amalga oshirilgan almashtirishlarni aniq kuzatish imkonini beradi, to‘plangan mukofotlaringizni kuzatish va boshqarishni osonlashtiradi.',
    see_more: 'Ko‘proq ko‘rish',
    see_less: 'Kamroq ko‘rish',

    //Faltantes
    upload_image: 'Rasmni yuklash',
    uploaded_image: 'Yuklangan rasm',
    photo: 'Foto',
    edit: 'Tahrirlash',
    delete: "O'chirish",
    enter_a_comment: 'Izoh kiriting',
    enter_a_value: 'Qiymat kiriting',
    want_to_check_out: 'Chiqish qilishni xohlayotganingizga ishonchingiz komilmi?',
    not_check_in_again: 'Bir marta tasdiqlangandan so´ng, keyingi tashrifingizgacha qayta ro´yxatdan o´ta olmaysiz.',

    //Alert
    alert: 'Ogohlantirish',
    enter_characters: 'Oldindan qoʻshimcha sifatida 10 ta belgini kiriting',
    numerical_field: 'Tahrirlanadigan maydon raqamli bo´lishi kerak, bo´sh joy yoki harflarsiz.',
    enter_date_of_birth: 'Tug‘ilgan sanani YYYY-AA-GG formatida to‘g‘ri kiriting.',
    session_expired: 'Sessiya muddati tugadi',
    your_session_has_expired: 'Sessiyangiz tugadi. Iltimos, qaytadan urinib ko‘ring.',
    error: 'Xato',
    error_occurred: 'Parolni o‘zgartirishda xato yuz berdi.',
    email_verification_code_incorrect: 'Elektron pochta tasdiqlash kodi noto‘g‘ri.',
    phone_verification_code_incorrect: 'Telefon tasdiqlash kodi noto‘g‘ri.',
    no_checkin_found: 'Kirish topilmadi.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
